//###########################################################################
// Navigation
//###########################################################################

import { throttle } from "../utilities/_throttle-debounce"

class Navigation {
    constructor() {
        const header = document.querySelector('#header')
        if (header) {
            const hamburgerButton = document.querySelector('.hamburger')
            const menuNav = header.querySelector('#site-nav')
            const menuDropdownTriggers = document.querySelectorAll('.sub-nav__hold > a')
            const menuDropdownBacks = document.querySelectorAll('.sub-nav__back')
            const menuDropdownBacksInner = document.querySelectorAll('.sub-nav__back--dropdown')
            const menuSubDropdownToggles = document.querySelectorAll('.sub-nav-dropdown-heading')
            const menuSubCategoryToggles = document.querySelectorAll('.sub-nav-category-heading')
            const searchButtons = document.querySelectorAll('.site-nav__search')
            const searchCloseBtn = document.querySelector('.search__close')
            // const basketButton = document.querySelector('.site-nav__basket')
            // const basketCross = document.querySelector('.cross--basket')
            let scrolled = false
            let hide = false
            let lastScrollPosition = 0

            hamburgerButton.addEventListener('click', e => {
                mainMenuToggle()
                searchClose()
            })

            for (let i = 0; i < menuDropdownTriggers.length; i++) {
                menuDropdownTriggers[i].addEventListener('click', e => {
                    if (document.documentElement.clientWidth < 993) {
                        e.preventDefault()
                        menuDropdownTriggers[i].parentElement.classList.add('open')

                        menuNav.scrollTop = 0
                        menuNav.classList.add('sub-open')
                    }
                })
            }

            for (let i = 0; i < menuSubCategoryToggles.length; i++) {
                menuSubCategoryToggles[i].addEventListener('click', e => {
                    if (document.documentElement.clientWidth < 993) {
                        e.preventDefault()
                        menuSubCategoryToggles[i].parentElement.classList.toggle('open')
                    }
                })
            }

            for (let i = 0; i < menuDropdownBacks.length; i++) {
                menuDropdownBacks[i].addEventListener('click', e => {
                    menuDropdownBacks[i].parentElement.parentElement.parentElement.classList.remove('open')
                    
                    if (menuDropdownBacks[i].parentElement.classList.contains('sub-nav__inner')) {
                      menuNav.scrollTop = 0
                      menuNav.classList.remove('sub-open')
                    }
                })
            }

            for (let i = 0; i < menuDropdownBacksInner.length; i++) {
                menuDropdownBacksInner[i].addEventListener('click', e => {
                    menuDropdownBacksInner[i].parentElement.parentElement.classList.remove('open')

                    menuDropdownBacksInner[i].closest('.sub-nav').scrollTop = 0
                    menuDropdownBacksInner[i].closest('.sub-nav').classList.remove('sub-open')
                })
            }

            for (let i = 0; i < menuSubDropdownToggles.length; i++) {
                menuSubDropdownToggles[i].addEventListener('click', e => {
                    menuSubDropdownToggles[i].parentElement.classList.toggle('open')

                    menuDropdownBacksInner[i].closest('.sub-nav').scrollTop = 0
                    menuSubDropdownToggles[i].closest('.sub-nav').classList.add('sub-open')
                })
            }

            for (let i = 0; i < searchButtons.length; i++) {
                searchButtons[i].addEventListener('click', e => {
                    e.preventDefault();
                    searchToggle()
                    mainMenuClose()
                    setTimeout(function () {
                        document.querySelector(".search input").focus();
                    }, 100);
                })
            }

            searchCloseBtn.addEventListener('click', e => {
                e.preventDefault()
                searchClose()
            })

            window.addEventListener('scroll', handleScroll)


            // Proper handling of body scroll when menu / search open
            //
            function onClassChange(node, callback) {
              let lastClassString = node.classList.toString();
            
              const mutationObserver = new MutationObserver((mutationList) => {
                for (const item of mutationList) {
                  if (item.attributeName === "class") {
                    const classString = node.classList.toString();
                    if (classString !== lastClassString) {
                      callback(mutationObserver);
                      lastClassString = classString;
                      break;
                    }
                  }
                }
              });
            
              mutationObserver.observe(node, { attributes: true });
            
              return mutationObserver;
            }

            onClassChange(header, (observer) => {
              if (header.classList.contains('header--open') || header.classList.contains('header--search')) {
                document.documentElement.style.overflow = 'hidden'
              } else {
                document.documentElement.style.overflow = ''
              }
            })

            function searchToggle() {
                document.body.classList.add('fix')
                header.classList.toggle('header--search')

                for (let i = 0; i < searchButtons.length; i++) {
                    searchButtons[i].classList.toggle('search--active')
                }
            }

            function searchClose() {
                document.body.classList.remove('fix')
                header.classList.remove('header--search')
                for (let i = 0; i < searchButtons.length; i++) {
                    searchButtons[i].classList.remove('search--active')
                }
            }

            function mainMenuToggle() {
                document.body.classList.toggle('fix')
                header.classList.toggle('header--open')
                hamburgerButton.classList.toggle('open')
            }

            function mainMenuClose() {
                document.body.classList.remove('fix')
                header.classList.remove('header--open')
                hamburgerButton.classList.remove('open')
            }

            function setNavHeight() {
              const submenus = header.querySelectorAll('.sub-nav, .sub-nav-dropdown')
          
              header.querySelector('#site-nav').style.height = (window.innerHeight - (header.clientHeight - 1)) + "px"
          
              for (let i = 0; i < submenus.length; i++) {
                const headerSubMenu = submenus[i]
          
                headerSubMenu.style.height = (window.innerHeight - (header.clientHeight - 1)) + "px"
              }
            }
          
            function unsetNavHeight() {
              const submenus = header.querySelectorAll('.sub-nav, .sub-nav-dropdown')
          
              header.querySelector('#site-nav').style.height = ""
          
              for (let i = 0; i < submenus.length; i++) {
                const headerSubMenu = submenus[i]
          
                headerSubMenu.style.height = ""
              }
            }

            // Set nav height
            //
            if (window.innerWidth < 992) {
              setNavHeight()
            }

            window.addEventListener('resize', throttle(function () {
              if (window.innerWidth < 992) {
                unsetNavHeight()
                setNavHeight()
              } else {
                unsetNavHeight()
              }
            }, 250))

            function handleScroll() {
                if (window.pageYOffset > 50 && !header.classList.contains('.header--scrolled')) {
                    scrolled = true
                    header.classList.add('header--scrolled')
                } else if (window.pageYOffset < 50) {
                    scrolled = false
                    header.classList.remove('header--scrolled')
                }

                if (document.querySelector('.header--scrolled') && document.querySelector('.stuck')) {
                    document.querySelector('#header').classList.add('header--no-shadow')
                } else {
                    document.querySelector('#header').classList.remove('header--no-shadow')
                }

                const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
                if (currentScrollPosition < 0) {
                    return
                }
                // Stop executing this function if the difference between
                // current scroll position and last scroll position is less than some offset
                if (Math.abs(currentScrollPosition - lastScrollPosition) < 80) {
                    return
                }
                hide = currentScrollPosition > lastScrollPosition
                if (hide) {
                    header.classList.add('header--hide')
                } else {
                    header.classList.remove('header--hide')
                }
                lastScrollPosition = currentScrollPosition
            }
        }
    }
}

export default Navigation
